var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-profile-collection-news"},[_c('JoLoadMore',{ref:"loadmore",attrs:{"auto-load":false},on:{"onRefresh":_vm.onRefresh,"onLoadMore":_vm.onLoadMore}},[_c('ul',_vm._l((_vm.newsList),function(news){return _c('li',{key:`collected-${news.id}`,staticClass:"news-item"},[_c('NewsCard',{attrs:{"news":news}})],1)}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }